import { getZoom } from "@/utils";

const baseLayer = {
  type: "fill",
  paint: {
    "fill-color": [
      "case",
      ["boolean", ["feature-state", "selected-1"], false],
      "#3cf1c6",
      ["boolean", ["feature-state", "selected-2"], false],
      "#ff0080",
      ["get", "custom-color"],
    ],
    "fill-opacity": [
      "case",
      ["boolean", ["feature-state", "selected-1"], false],
      0.6,
      ["boolean", ["feature-state", "selected-2"], false],
      0.6,
      ["boolean", ["feature-state", "hover"], false],
      0.3,
      0.2,
    ],
    "fill-opacity-transition": {
      duration: 200,
    },
  },
};

export const countriesLayer = {
  ...baseLayer,
  id: "world-countries",
  maxzoom: getZoom("country", true),
};

export const districtsLayer = {
  ...baseLayer,
  id: "eng-districts",
  minzoom: getZoom("district", false),
  maxzoom: getZoom("district", true),
};

export const citiesLayer = {
  ...baseLayer,
  id: "eng-cities",
  minzoom: getZoom("city", false),
  maxzoom: getZoom("city", true),
};

export const boroughsLayer = {
  ...baseLayer,
  id: "london-boroughs",
  minzoom: getZoom("borough", false),
};

export const heatmapLayer = {
  id: "thefts-heatmap",
  type: "heatmap",
  source: "heatmap",
  minzoom: 4,
  maxzoom: 12,
  paint: {
    "heatmap-weight": {
      stops: [
        [1, 0.2],
        [22, 1],
      ],
    },
    // increase intensity as zoom level increases
    "heatmap-intensity": {
      stops: [
        [11, 1],
        [15, 3],
      ],
    },
    // assign color values to points depending on their density
    "heatmap-color": [
      "interpolate",
      ["linear"],
      ["heatmap-density"],
      0,
      "rgba(255,255,178,0)",
      0.2,
      "rgb(254,204,92)",
      0.4,
      "rgb(253,141,60)",
      0.6,
      "rgb(240,59,32)",
      0.8,
      "rgb(189,0,38)",
    ],
    // increase radius as zoom increases
    "heatmap-radius": {
      stops: [
        [8, 10],
        [22, 20],
      ],
    },
    // decrease opacity to transition into the circle layer
    "heatmap-opacity": {
      stops: [
        [14, 1],
        [22, 0.3],
      ],
    },
  },
  "fill-opacity-transition": {
    duration: 200,
  },
};

export const circleLayer = {
  id: "theft-point",
  type: "circle",
  source: "heatmap",
  minzoom: 12,
  paint: {
    // Size circle radius by earthquake magnitude and zoom level
    "circle-radius": {
      stops: [
        [12, 5],
        [18, 6],
        [20, 7],
        [22, 8],
      ],
    },
    "circle-color": {
      stops: [
        [12, "rgba(254,229,217,0)"],
        [15, "rgb(252,187,161)"],
        [18, "rgb(252,146,114)"],
        [22, "rgb(251,106,74)"],
      ],
    },
    "circle-stroke-color": "white",
    "circle-stroke-width": 1,
    "circle-opacity": 0.3,
  },
};

export const userRadiusLayer = {
  source: "user-marker",
  type: "fill",
  paint: {
    "fill-color": "#f15b3c",
    "fill-opacity": 0.2,
  },
};

export const radiusLayer1 = {
  source: "search-marker-1",
  type: "fill",
  paint: {
    "fill-color": "#3cf1c6",
    "fill-opacity": 0.2,
  },
};

export const radiusLayer2 = {
  source: "search-marker-2",
  type: "fill",
  paint: {
    "fill-color": "#ff0080",
    "fill-opacity": 0.2,
  },
};
